import script from "./zj.vue?vue&type=script&setup=true&lang=js"
export * from "./zj.vue?vue&type=script&setup=true&lang=js"

import "./zj.vue?vue&type=style&index=0&id=467f8ad4&scoped=true&lang=scss"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-467f8ad4"]])

export default __exports__